"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

function _boolean(object, settings) {
  var key = settings.key;
  var val = object[key];
  return parseBoolean(val);
}

module.exports = _boolean;